export enum Routes {
  Home = "/",
  Template = "/templates",
  About = "/about",
  СapabilityStatement = "/capability-statement",
}
